import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { fetchContactMessages } from '../services/contact';
import './Contact.css';

const ContactMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const getMessages = async () => {
      try {
        const data = await fetchContactMessages();
        setMessages(data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    getMessages();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[100vh]">
        <img
          src="/loading.gif"
          alt="Loading..."
          className="w-30 h-30 object-contain"
        />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center min-h-[100vh]">
        <img
          src="/empty.png"
          alt="Error occurred"
          className="w-64 h-auto object-contain mb-4"
        />
        <p className="text-red-500 font-medium">Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="mb-4">
        <button
          onClick={() => navigate(-1)}
          className="
            inline-flex
            items-center
            gap-2
            px-4
            py-2
            rounded-lg
            border
            bg-gray-300
            border-gray-300
            text-gray-700
            text-sm
            font-medium
            hover:bg-gray-400
            transition
          "
        >
          <ArrowLeft size={18} />
          Back
        </button>
      </div>

      <h1 className="text-xl font-semibold text-gray-800 mb-4">
        Contact Messages
      </h1>

      <div className="w-full overflow-hidden border border-gray-200 rounded-lg">
        <div className="w-full overflow-x-auto">
          <table className="min-w-full text-left text-sm whitespace-nowrap">
            <thead className="bg-gray-100 border-b border-gray-200">
              <tr>
                <th className="px-4 py-3 font-semibold text-gray-600">Name</th>
                <th className="px-4 py-3 font-semibold text-gray-600">Email</th>
                <th className="px-4 py-3 font-semibold text-gray-600">Mobile</th>
                <th className="px-4 py-3 font-semibold text-gray-600 min-w-[200px]">Message</th>
                <th className="px-4 py-3 font-semibold text-gray-600">Created At</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {messages.map((message) => (
                <tr key={message._id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-gray-900">{message.name}</td>
                  <td className="px-4 py-3 text-gray-900">{message.email}</td>
                  <td className="px-4 py-3 text-gray-900">{message.mobile}</td>
                  <td className="px-4 py-3 text-gray-900 whitespace-normal min-w-[300px]">{message.message}</td>
                  <td className="px-4 py-3 text-gray-900">
                    {new Date(message.createdAt).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {messages.length === 0 && (
            <div className="p-6 text-center text-gray-500">
              No messages found.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactMessages;
